module.exports = __webpack_public_path__ + "static/img/LAL_Selected.6245d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/LAL_Selected.png
// module id = 1572
// module chunks = 0